import { constants } from '@/config/constants';
import { IS_WEB } from '@/utils/platform';

const OBS_ASSET_ORIGIN =
  /^https:\/\/neolexon(-stage)?-assets\.obs(-website)?\.eu-de\.otc\.t-systems\.com(?=\/)/;

/**
 * Hotfix: on web, points OBS asset URLs at constants.webAssetOrigin and keeps
 * path and query. Native apps and other URLs are returned unchanged.
 */
export const toWebAssetUrl = <T extends string | undefined | null>(
  url: T,
): T => {
  if (!IS_WEB || !constants.webAssetOrigin || !url) {
    return url;
  }
  return url.replace(OBS_ASSET_ORIGIN, constants.webAssetOrigin) as T;
};
